import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, NoPreloading, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';

// Import functional interceptors
import { authInterceptorFn } from './core/interceptors/auth.interceptor';
import { GlobalErrorHandler } from './services/global-error.handler';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(NoPreloading)),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  
    provideAnimationsAsync(),

    // HTTP Client with functional interceptors
    provideHttpClient(
      withInterceptors([authInterceptorFn])
    ),

    // PrimeNG Configuration
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none'
        }
      }
    }),

    // PrimeNG Services
    MessageService
  ]
};
